/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Invoice_Transfer_Dated_In_LedgerInputs */

const fr_api_invoice_transfer_dated_in_ledger = /** @type {(inputs: Api_Invoice_Transfer_Dated_In_LedgerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suppression impossible : une date de valeur de virement est déjà renseignée pour cette ligne dans le fichier Excel.`)
};

const en_api_invoice_transfer_dated_in_ledger = /** @type {(inputs: Api_Invoice_Transfer_Dated_In_LedgerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cannot delete: a transfer value date is already filled in for this row in the Excel file.`)
};

/**
* | output |
* | --- |
* | "Cannot delete: a transfer value date is already filled in for this row in the Excel file." |
*
* @param {Api_Invoice_Transfer_Dated_In_LedgerInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const api_invoice_transfer_dated_in_ledger = /** @type {((inputs?: Api_Invoice_Transfer_Dated_In_LedgerInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Invoice_Transfer_Dated_In_LedgerInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_invoice_transfer_dated_in_ledger(inputs)
	return fr_api_invoice_transfer_dated_in_ledger(inputs)
});